import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AboutMFONavService {
  private navState = new BehaviorSubject<boolean>(false);
  public navState$ = this.navState.asObservable();

  private statusUpdate = new BehaviorSubject<string>('');
  public statusUpdate$ = this.statusUpdate.asObservable();

  constructor(private http: HttpClient) {}

  handleNav(state: boolean) {
    this.navState.next(state);
  }

  handleAboutMFOStatusUpdate(status: string) {
    this.statusUpdate.next(status);
  }

}
